<div class="body-container-wrapper">
  <section class="no-padding aboutSB-head-seaction bg-white">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-md-12">
          <div class="breadcrumb-menu">
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="./about-us">About Us</a>
              </li>
              <li>
                <a href="javascript:void(0)">CEO</a>
              </li>
            </ul>
          </div>
        </div>

      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="image">
            <img src="../../assets/images/ceo.png" alt="Venkatesh Naidu" />
          </div>
          <div class=""></div>
        </div>
        <div class="col-md-8">
          <div class="aboutDetail">
            <h3 class="about-heading">Venkatesh Naidu</h3>
            <p class="Sposition">CEO - BajajCapital Insurance</p>

            <ul class="socialLinks ps-0">
              <li>Follow him:</li>
              <!-- <li *ngFor="let sl of social_links">
                            <a [href]="sl.description" target="_blank" [title]="sl.title"><img [src]="sl.icon" [alt]="sl.title"></a>
                        </li> -->
            </ul>
            <a download="CEO.pdf" title="CEO Profile" target="_blank"><span class="uploadProfile">Download Profile <i
                  class="fa fa-download"></i></span></a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="aboutSB-content bg-white">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <div class="aboutSBTabPannel tab-pannel">
            <ul class="nav flex-column nav-pills d-none" id="v-pills-tab" role="tablist" aria-orientation="vertical">
              <!-- <ng-container *ngFor="let area of profile_area; let i = index;">
                   <li><a [ngClass]="i == 0 ? 'nav-link active' : 'nav-link'"   id="v-pills-home-tab{{i}}"  data-bs-toggle="pill" href="#v-pills-home{{i}}"  role="tab"  [attr.aria-controls]="'v-pills-home'+i"  aria-selected="true">{{area.tab}}</a></li> 
                </ng-container> -->
            </ul>
          </div>
          <!-- <div class="mobileTabSelect">
                  <div class="form-group custom-dropdown">
                  <span class="selected-item form-control">{{firstTab}}</span>
            <ul>
                <ng-container *ngFor="let mobarea of profile_area;let i=index;">
                    <li [attr.id]="'mtab'+i"><a  [ngClass]="i == 0 ? 'nav-link active' : 'nav-link'"   id="v-pills-home-tab{{i}}"  data-bs-toggle="pill"   role="tab"  [attr.aria-controls]="'v-pills-home'+i"  aria-selected="true"  (click)="selectMTopic(mobarea.tab,i)" href="javascript:void(0)">{{mobarea.tab}}</a></li> 
                </ng-container>
            </ul>
                  </div>                   
            </div> -->
        </div>
        <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
          <div class="tab-content" id="v-pills-tabContent">
            <!-- <ng-container *ngFor="let areacontent of profile_area;let i = index;">
                    <div [ngClass]="i == classVar ? 'tab-pane fade show active' : 'tab-pane fade'" role="tabpanel" id="v-pills-home{{i}}" [attr.aria-labelledby]="'v-pills-home-tab'+i">
                <div class="content">
                    <span [innerHTML]="areacontent.content"></span>
                   
                </div>
              </div>
            </ng-container> -->
          </div>
        </div>
      </div>
    </div>
  </section>


  <section class="bgwhite articles-listing-section" id="gallery_section">
    <div class="container">
      <div class="row">
        <div class="col-12 card">
          <h2 class="card-title pt-3">Gallery <span class="wow"></span></h2>
        </div>
      </div>
      <div class="articles-carousel" id="profile-gallery">
        <!-- <ng-container *ngFor="let blogPost of profile_gallery;let i = last;">
                <div class="item ">
                    <a  class="card grey-card articles-card">

                        <img [src]="blogPost.icon_image ? blogPost.icon_image : ''"  alt="" class="card-img-top" >
                       
                        <div class="card-body">
                            <p [innerHTML]="blogPost.description"></p>
                        </div>
                    </a>
                </div>
               
                </ng-container> -->
      </div>
    </div>
  </section>
</div>